<template>
  <div>
    <el-table ref="table" :data="items" border fit highlight-current-row style="width: 100%" height="575">
      <el-table-column width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.linkedYN"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('fabric.description')" min-width="150">
        <template slot-scope="scope">
          <span>
            {{ scope.row.description }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.fabricType')" min-width="150">
        <template slot-scope="scope">
          <span>
            {{ scope.row.fabricTypeOption | fabricTypeOptionFilter }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { FabricTypeOptionNames } from '@/utils/constants';
export default {
  name: 'FabricTypesList',
  filters: {
    fabricTypeOptionFilter(value) {
      return FabricTypeOptionNames[value];
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    value(value) {
      this.items = value;
    }
  }
};
</script>
